export const throttle = <T extends unknown[]>(
    callback: (...values: T) => void,
    timeoutMs: number,
    leading = false,
): [(...v: T) => void, () => void] => {
    let currentValue: T | null = null;
    let interval: number | null;

    const cancel = () => {
        if (interval) {
            clearInterval(interval);
            currentValue = null;
            interval = null;
        }
    };

    return [
        (...values: T) => {
            if (leading && !interval) {
                callback(...values);
            }

            if (!interval) {
                interval = window.setInterval(() => {
                    // If new values arrived since the last interval tick, invoke callback.
                    if (currentValue && currentValue !== values) {
                        callback(...currentValue);
                        currentValue = null;
                    } else {
                        // No new values -> stop.
                        cancel();
                    }
                }, timeoutMs);
            }

            currentValue = values;
        },
        cancel,
    ];
};

export const debounce = <T extends unknown[]>(callback: (...values: T) => void, timeoutMs: number): [(...v: T) => void, () => void] => {
    let timeoutRef: number | null = null;

    const cancel = () => {
        if (timeoutRef) {
            clearTimeout(timeoutRef);
            timeoutRef = null;
        }
    };

    return [
        (...values: T) => {
            if (timeoutRef) {
                clearTimeout(timeoutRef);
            }
            timeoutRef = window.setTimeout(() => {
                callback(...values);
                timeoutRef = null;
            }, timeoutMs);
        },
        cancel,
    ];
};

export const mod = (current: number, count: number) => ((current % count) + count) % count;

export const generateSrcSet = (image: string | undefined) => {
    if (!image) return '';
    const sizes = ['1600w', '1280w', '960w', '640w', '320w', '142w']; // These are the sizes that have webp from YAMS
    return sizes.map((size) => `${image.replaceAll('default', `${size}_webp`)} ${size}`).join(',');
};

export const getLowResImageUrl = (image: string) => image.replaceAll('default', '142w');

const getImage = (number: number) => document.getElementById(`image-${number}`);

export const loadImage = (number: number) => getImage(number)?.setAttribute('srcset', getImage(number)?.getAttribute('data-srcset') ?? '');
